import { z } from "zod";

/** A country, as ISO 3166-1 alpha-2 in capitals. */
export const purchaseCountrySchema = z.string().regex(/^[A-Z]{2}$/);

/** Where an estimate is asked to deliver: the country, its postcode read
 *  under the country's rules, and the country's region where it has
 *  regions ("US-NY", or a typed one). Nothing more of the address. */
export const destinationSchema = z
  .object({
    country: purchaseCountrySchema,
    postcode: z.string().max(240).nullable(),
    region: z.string().max(240).nullable(),
  })
  .strict();
export type Destination = z.infer<typeof destinationSchema>;
